import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import hu from './locales/hu.json';
import he from './locales/he.json';
import adminEn from './locales/admin/en.json';
import adminHu from './locales/admin/hu.json';
import adminHe from './locales/admin/he.json';

const resources = {
  en: { translation: { ...en, admin: adminEn } },
  hu: { translation: { ...hu, admin: adminHu } },
  he: { translation: { ...he, admin: adminHe } }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'hu', 'he'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    react: {
      useSuspense: false
    }
  });

// Set document direction for RTL (Hebrew)
const applyLangDir = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
};

i18n.on('languageChanged', applyLangDir);
// Apply on init (languageChanged may not fire immediately)
applyLangDir(i18n.language || 'en');

export default i18n;
